import { PreQuerySizeGuideData } from '../types';
import {
  howToChooseSizeHoodieInstructions,
  internationalConversions,
  LIGHTWEIGHT_HOODIE_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 6
 * Lightweight Hoodie, Lightweight Sweatshirt
 * whinging-magpie, aggro-emu
 * Data source: https://www.figma.com/file/APrcJzL2qFEoaRd5cHKcR6/Sizing---VM?node-id=102%3A1188&t=HmvOZ0xrFXTSRYSx-1
 */

export const experience6: PreQuerySizeGuideData = {
  internationalConversions,
  fitIndicator: {
    value: 2 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: LIGHTWEIGHT_HOODIE_ILLUSTRATION_PATH,
    instructions: howToChooseSizeHoodieInstructions,
  },
};
